import {alpha, styled} from "@mui/system";
import {Box as MuiBox} from "@mui/material";

export const OutlinedBox = styled(MuiBox)(({theme}) => {
  return {
    border: `1px solid ${theme.palette.borderColor.one}`,
    borderRadius: 12,
  }
})

export default {OutlinedBox}